import { FeatureList } from '../types/api';

// Утилиты для работы с фич-листом
export const getTotalFeatures = (featureList: FeatureList): number => {
  return featureList.groups.reduce((total, group) => total + group.features.length, 0);
};

export const getTotalGroups = (featureList: FeatureList): number => {
  return featureList.groups.length;
};

// Утилиты для копирования в буфер обмена
export const createTableHTML = (featureList: FeatureList): string => {
  let htmlContent = `
    <table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse; font-family: Arial, sans-serif;">
      <thead>
        <tr style="background-color: #f5f5f5;">
          <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Группа</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">№</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Название фичи</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Описание</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Приоритет</th>
          <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Ограничения</th>
        </tr>
      </thead>
      <tbody>
  `;
  
  featureList.groups.forEach(group => {
    group.features.forEach(feature => {
      htmlContent += `
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px;">${group.groupName}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${feature.featureNumber}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${feature.featureName}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${feature.featureDescription}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${getPriorityLabel(feature.priority)}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${feature.restrictions}</td>
        </tr>
      `;
    });
  });
  
  htmlContent += `
      </tbody>
    </table>
  `;

  return htmlContent;
};

export const createTableText = (featureList: FeatureList): string => {
  let textContent = 'Группа\t№\tНазвание фичи\tОписание\tПриоритет\tОграничения\n';
  
  featureList.groups.forEach(group => {
    group.features.forEach(feature => {
      textContent += `${group.groupName}\t${feature.featureNumber}\t${feature.featureName}\t${feature.featureDescription}\t${getPriorityLabel(feature.priority)}\t${feature.restrictions}\n`;
    });
  });

  return textContent;
};

// Утилиты для приоритетов
export const getPriorityColor = (priority: number): 'error' | 'warning' | 'success' | 'default' => {
  switch (priority) {
    case 1: return 'error';
    case 2: return 'warning';
    case 3: return 'success';
    default: return 'default';
  }
};

export const getPriorityLabel = (priority: number): string => {
  switch (priority) {
    case 1: return 'Высокий';
    case 2: return 'Средний';
    case 3: return 'Низкий';
    default: return `Приоритет ${priority}`;
  }
};

// Утилиты для валидации
export const isValidFeatureList = (data: any): data is FeatureList => {
  return data && 
         typeof data === 'object' && 
         Array.isArray(data.groups) && 
         data.groups.length > 0;
};
